import { flowTypes } from "../types";

const initialState = {
    flowModeRequest: false,
    flowModeSuccess: null,
    flowModeFailure: null,
    fetchingInsights: false,
    fetchedInsightsSuccess: null,
    fetchedInsightsFailure: null,
    sendingFlowFeedback: false,
    sentFlowFeedbackSuccess: null,
    sentFlowFeedbackFailure: null,
    showPreviousChatLayout: true,
};

export const flow = (state = initialState, action: { type: string; payload: any }) => {
    switch (action.type) {
        case flowTypes.FLOW_MODE_REQUEST:
            return {
                ...state,
                flowModeRequest: true,
                flowModeSuccess: null,
                flowModeFailure: null,
            };
        case flowTypes.FLOW_MODE_SUCCESS:
            return {
                ...state,
                flowModeRequest: false,
                flowModeSuccess: action.payload,
                flowModeFailure: null,
            };
        case flowTypes.FLOW_MODE_FAILURE:
            return {
                ...state,
                flowModeRequest: false,
                flowModeFailure: action.payload,
                flowModeSuccess: null,
            };
        case flowTypes.FETCH_INSIGHTS_REQUEST:
            return {
                ...state,
                fetchingInsights: true,
                fetchedInsightsSuccess: null,
                fetchedInsightsFailure: null,
            };
        case flowTypes.FETCH_INSIGHTS_SUCCESS:
            return {
                ...state,
                fetchingInsights: false,
                fetchedInsightsSuccess: action.payload,
                fetchedInsightsFailure: null,
            };
        case flowTypes.FETCH_INSIGHTS_FAILURE:
            return {
                ...state,
                fetchingInsights: false,
                fetchedInsightsFailure: action.payload,
                fetchedInsightsSuccess: null,
            };
        case flowTypes.SEND_FLOW_FEEDBACK_REQUEST:
            return {
                ...state,
                sendingFlowFeedback: true,
                sentFlowFeedbackSuccess: null,
                sentFlowFeedbackFailure: null,
            };
        case flowTypes.SEND_FLOW_FEEDBACK_SUCCESS:
            return {
                ...state,
                sendingFlowFeedback: false,
                sentFlowFeedbackSuccess: action.payload,
                sentFlowFeedbackFailure: null,
            };
        case flowTypes.SEND_FLOW_FEEDBACK_FAILURE:
            return {
                ...state,
                sendingFlowFeedback: false,
                sentFlowFeedbackFailure: action.payload,
                sentFlowFeedbackSuccess: null,
            };
        case flowTypes.SHOW_PREVIOUS_CHAT_LAYOUT:
            return {
                ...state,
                showPreviousChatLayout: action.payload,
            };
        default:
            return state;
    }
};
